import React from "react";

/**
 * A compact selector rendered as a group of buttons.
 * `buttons` maps values to labels. Pass a string for single selection or an
 * array with `multiple` enabled for multi selection.
 */
const ButtonSelect = ({
  buttons,
  ariaLabel,
  selected,
  onChange,
  multiple = false,
  disabled = false,
  className = "d-flex flex-row ms-md-2 border",
  style,
  buttonClassName = "btn btn-small",
  lastButtonClassName = "",
  selectedClassName = "primary-color-background text-white",
  unselectedClassName = "text-main",
}) => {
  const selectedValues = multiple ? (Array.isArray(selected) ? selected : []) : [selected];

  const select = (value) => {
    if (multiple) {
      const values = selectedValues.includes(value)
        ? selectedValues.filter((item) => item !== value)
        : [...selectedValues, value];
      onChange?.(values);
    } else {
      onChange?.(value);
    }
  };

  return (
    <div className={className} style={style} role={ariaLabel ? "group" : undefined} aria-label={ariaLabel}>
      {Object.entries(buttons).map(([value, label], index, entries) => {
        const isSelected = selectedValues.includes(value);
        const isDisabled = disabled === true || (Array.isArray(disabled) && disabled.includes(value)) ||
          (typeof disabled === "object" && !Array.isArray(disabled) && Boolean(disabled?.[value]));
        return (
          <button
            key={value}
            type="button"
            className={`${buttonClassName}${index === entries.length - 1 ? ` ${lastButtonClassName}` : ""}${isSelected ? ` ${selectedClassName}` : ` ${unselectedClassName}`}`}
            onClick={() => select(value)}
            disabled={isDisabled}
            aria-pressed={isSelected}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default ButtonSelect;
